// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BestFitPharmacyRequestSearchResponse } from './bestFitPharmacyRequestSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': BestFitPharmacyRequestSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "BestFitPharmacyRequestSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse.attributeTypeMap;
    }
}
